var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-toast',{attrs:{"variant":_vm.showAlert.type,"auto-hide":"","solid":"","visible":_vm.showAlert.show},on:{"hidden":function($event){return _vm.onHide($event)}}},[_vm._v(_vm._s(_vm.showAlert.message))])}
var staticRenderFns = []

export { render, staticRenderFns }